/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {defineInjectable, defineInjector,} from '../../di/defs';
import {inject} from '../../di/injector_compatibility';
import * as r3 from '../index';
import * as sanitization from '../../sanitization/sanitization';


/**
 * A mapping of the @angular/core API surface used in generated expressions to the actual symbols.
 *
 * This should be kept up to date with the public exports of @angular/core.
 */
export const angularCoreEnv: {[name: string]: Function} = {
  'ÉµdefineBase': r3.defineBase,
  'ÉµdefineComponent': r3.defineComponent,
  'ÉµdefineDirective': r3.defineDirective,
  'defineInjectable': defineInjectable,
  'defineInjector': defineInjector,
  'ÉµdefineNgModule': r3.defineNgModule,
  'ÉµdefinePipe': r3.definePipe,
  'ÉµdirectiveInject': r3.directiveInject,
  'ÉµgetFactoryOf': r3.getFactoryOf,
  'ÉµgetInheritedFactory': r3.getInheritedFactory,
  'inject': inject,
  'ÉµinjectAttribute': r3.injectAttribute,
  'ÉµtemplateRefExtractor': r3.templateRefExtractor,
  'ÉµNgOnChangesFeature': r3.NgOnChangesFeature,
  'ÉµProvidersFeature': r3.ProvidersFeature,
  'ÉµInheritDefinitionFeature': r3.InheritDefinitionFeature,
  'ÉµelementAttribute': r3.elementAttribute,
  'Éµbind': r3.bind,
  'Éµcontainer': r3.container,
  'ÉµnextContext': r3.nextContext,
  'ÉµcontainerRefreshStart': r3.containerRefreshStart,
  'ÉµcontainerRefreshEnd': r3.containerRefreshEnd,
  'ÉµloadQueryList': r3.loadQueryList,
  'ÉµnamespaceHTML': r3.namespaceHTML,
  'ÉµnamespaceMathML': r3.namespaceMathML,
  'ÉµnamespaceSVG': r3.namespaceSVG,
  'ÉµenableBindings': r3.enableBindings,
  'ÉµdisableBindings': r3.disableBindings,
  'ÉµallocHostVars': r3.allocHostVars,
  'ÉµelementStart': r3.elementStart,
  'ÉµelementEnd': r3.elementEnd,
  'Éµelement': r3.element,
  'ÉµelementContainerStart': r3.elementContainerStart,
  'ÉµelementContainerEnd': r3.elementContainerEnd,
  'ÉµpureFunction0': r3.pureFunction0,
  'ÉµpureFunction1': r3.pureFunction1,
  'ÉµpureFunction2': r3.pureFunction2,
  'ÉµpureFunction3': r3.pureFunction3,
  'ÉµpureFunction4': r3.pureFunction4,
  'ÉµpureFunction5': r3.pureFunction5,
  'ÉµpureFunction6': r3.pureFunction6,
  'ÉµpureFunction7': r3.pureFunction7,
  'ÉµpureFunction8': r3.pureFunction8,
  'ÉµpureFunctionV': r3.pureFunctionV,
  'ÉµgetCurrentView': r3.getCurrentView,
  'ÉµrestoreView': r3.restoreView,
  'Éµinterpolation1': r3.interpolation1,
  'Éµinterpolation2': r3.interpolation2,
  'Éµinterpolation3': r3.interpolation3,
  'Éµinterpolation4': r3.interpolation4,
  'Éµinterpolation5': r3.interpolation5,
  'Éµinterpolation6': r3.interpolation6,
  'Éµinterpolation7': r3.interpolation7,
  'Éµinterpolation8': r3.interpolation8,
  'ÉµinterpolationV': r3.interpolationV,
  'ÉµelementClassProp': r3.elementClassProp,
  'Éµlistener': r3.listener,
  'Éµload': r3.load,
  'Éµprojection': r3.projection,
  'ÉµelementProperty': r3.elementProperty,
  'ÉµcomponentHostSyntheticProperty': r3.componentHostSyntheticProperty,
  'ÉµpipeBind1': r3.pipeBind1,
  'ÉµpipeBind2': r3.pipeBind2,
  'ÉµpipeBind3': r3.pipeBind3,
  'ÉµpipeBind4': r3.pipeBind4,
  'ÉµpipeBindV': r3.pipeBindV,
  'ÉµprojectionDef': r3.projectionDef,
  'Éµpipe': r3.pipe,
  'Éµquery': r3.query,
  'ÉµqueryRefresh': r3.queryRefresh,
  'ÉµregisterContentQuery': r3.registerContentQuery,
  'Éµreference': r3.reference,
  'ÉµelementStyling': r3.elementStyling,
  'ÉµelementHostAttrs': r3.elementHostAttrs,
  'ÉµelementStylingMap': r3.elementStylingMap,
  'ÉµelementStyleProp': r3.elementStyleProp,
  'ÉµelementStylingApply': r3.elementStylingApply,
  'Éµtemplate': r3.template,
  'Éµtext': r3.text,
  'ÉµtextBinding': r3.textBinding,
  'ÉµembeddedViewStart': r3.embeddedViewStart,
  'ÉµembeddedViewEnd': r3.embeddedViewEnd,
  'Éµi18n': r3.i18n,
  'Éµi18nAttributes': r3.i18nAttributes,
  'Éµi18nExp': r3.i18nExp,
  'Éµi18nStart': r3.i18nStart,
  'Éµi18nEnd': r3.i18nEnd,
  'Éµi18nApply': r3.i18nApply,
  'Éµi18nPostprocess': r3.i18nPostprocess,

  'ÉµsanitizeHtml': sanitization.sanitizeHtml,
  'ÉµsanitizeStyle': sanitization.sanitizeStyle,
  'ÉµdefaultStyleSanitizer': sanitization.defaultStyleSanitizer,
  'ÉµsanitizeResourceUrl': sanitization.sanitizeResourceUrl,
  'ÉµsanitizeScript': sanitization.sanitizeScript,
  'ÉµsanitizeUrl': sanitization.sanitizeUrl
};
